import React from "react";
import "./register.scss";
import { Link } from "react-router-dom";
import SmsValidator from "../../../components/SmsValidator";
import InputMask from "react-input-mask";
import GRecaptcha from "../../../components/GRecaptcha";
import useRegister from "./useRegister";

const Register = () => {
  const {
    form,
    formik,
    isPerson,
    towns,
    district,
    isLoading,
    ShowSmsValidatorModal,
    setShowSmsValidatorModal,
    dataAddress,
    branches,
    branchesLoading,
  } = useRegister();

  return (
    <div className="RegisterContainer flex flex-col animate__animated animate__fadeIn">
      <div className="font-bold text-4xl w-full">
        <Link to="/">
          <img className="w-96" src="/assets/images/logo.png" alt="Logo" />
        </Link>
      </div>
      <div className="flex font-bold justify-center mt-4">
        <div {...form.legal}>Tüzel</div>
        <div {...form.person}>Şahıs</div>
      </div>
      <div className="mt-2 text-xs justify-center flex flex-col items-center font-semibold">
        {isPerson ? "Şahıs" : "Tüzel"} olarak kayıt oluyorsunuz.
        <div className="text-xs font-semibold items-center flex ">
          Doldurulması zorunlu alanlar <span className="text-red-500 md:text-lg mx-1"> * </span>ile belirtilmiştir.
        </div>
      </div>

      <div className="mt-6 flex flex-col font-normal">
        <form onSubmit={formik.handleSubmit} className="w-full">
          <div className="relative">
            <input {...form.idNo} />
            <span className="absolute right-4 text-red-600 text-2xl top-3 ">*</span>
          </div>

          <span className="text-xs font-semibold flex text-red-600 duration-300">
            {formik.touched.idNo && formik.errors.idNo}
          </span>
          <div className="mt-2 flex flex-col font-normal relative">
            <InputMask {...form.gsm} />
            <span className="absolute right-4 text-red-600 text-2xl top-3 ">*</span>
          </div>
          <span className="text-xs font-semibold flex text-red-600 duration-300">
            {formik.touched.gsm && formik.errors.gsm}
          </span>
          <div className="mt-2 flex flex-col font-normal">
            <input {...form.email} />
          </div>
          <span className="text-xs font-semibold flex text-red-600 duration-300">
            {formik.touched.email && formik.errors.email}
          </span>
          <div className="mt-2 flex flex-col font-normal relative">
            <input {...form.title} />
            <span className="absolute right-4 text-red-600 text-2xl top-3 ">*</span>
          </div>
          <span className="text-xs font-semibold flex text-red-600 duration-300">
            {formik.touched.title && formik.errors.title}
          </span>
          <div className="mt-2 flex flex-col font-normal">
            <input {...form.relatedPerson} />
          </div>
          <span className="text-xs font-semibold flex text-red-600 duration-300">
            {formik.touched.relatedPerson && formik.errors.relatedPerson}
          </span>
          <div className="mt-2 flex flex-col font-normal relative">
            <select {...form.idBranch}>
              {branchesLoading ? (
                <option value="">Yükleniyor...</option>
              ) : (
                branches?.map((branch) => (
                  <option key={branch.idBranch} value={branch.idBranch}>
                    {branch.branchName}
                  </option>
                ))
              )}
            </select>
            <span className="absolute right-4 text-red-600 text-2xl top-3 ">*</span>
          </div>
          <span className="text-xs font-semibold flex text-red-600 duration-300">
            {formik.touched.idBranch && formik.errors.idBranch}
          </span>
          <div className="mt-2 flex flex-col font-normal">
            <select {...form.idCity}>
              {dataAddress.data &&
                dataAddress.data.data[0].cities.map((x) => {
                  return (
                    <option key={x.id} value={x.id}>
                      {x.name}
                    </option>
                  );
                })}
            </select>
          </div>
          <span className="text-xs font-semibold flex text-red-600 duration-300">
            {formik.touched.idCity && formik.errors.idCity}
          </span>
          <div className="mt-2 flex flex-col font-normal">
            <select {...form.idTown}>
              <option value={null}>İlçe</option>
              {towns.map((e) => {
                return (
                  <option key={e.id} value={e.id}>
                    {e.name}
                  </option>
                );
              })}
            </select>
          </div>
          <div className="mt-2 flex flex-col font-normal">
            <select {...form.idDistrict}>
              <option value={null}>Köy / Mahalle</option>
              {district &&
                district.data.data.map((g) => {
                  return (
                    <option key={g.idDistrict} value={g.idDistrict}>
                      {g.name}
                    </option>
                  );
                })}
            </select>
          </div>
          <div className="mt-2 flex flex-col font-normal">
            <input {...form.address1} />
          </div>

          <div className="mt-2 flex flex-col font-normal">
            <input {...form.address2} />
          </div>
          <GRecaptcha {...form.gRecaptcha} />

          <div className="justify-center flex mt-2">
            <button {...form.registerButton}>{isLoading ? "Kayıt olunuyor..." : "Kayıt Ol"}</button>
          </div>
        </form>
      </div>
      <SmsValidator
        isOpen={ShowSmsValidatorModal}
        formikData={formik.values}
        onClose={() => setShowSmsValidatorModal(false)}
      />
    </div>
  );
};

export default Register;
